import axios from 'axios'
import qs from 'qs'

// Vue.http.options.xhr = {withCredentials: true}
// Vue.http.options.emulateJSON = true

let http = axios.create({
  withCredentials: true
})

export default {
  install (Vue, options) {
    let api = options.api
    let level = options.level

    Vue.prototype.$user = function () {
      let step1 = function (value) {
        let params = {
          function: 'autho',
          method: 'pstep1',
          pid: value
        }

        return new Promise((resolve, reject) => {
          http.post(api, qs.stringify(params)).then(response => {
            let status = response.data.Function.success
            if (!status) {
              reject()
              return false
            }
            resolve()
          })
        })
      }

      let step2 = function (value) {
        let params = {
          function: 'autho',
          method: 'pstep2',
          code: value
        }

        return new Promise((resolve, reject) => {
          http.post(api, qs.stringify(params)).then(response => {
            let status = response.data.Function.success
            if (!status) {
              reject()
              return false
            }
            resolve()
          })
        })
      }

      let login = function (user) {
        let params = {
          function: 'autho',
          method: 'login',
          site: level,
          username: user.username,
          password: user.password
        }

        return new Promise((resolve, reject) => {
          http.post(api, qs.stringify(params)).then(response => {
            let status = response.data.Function.success
            if (!status) {
              reject(false)
              return false
            }
            resolve(response.data.Data)
          })
        })
      }

      let logout = function () {
        let params = {
          function: 'autho',
          method: 'logout'
        }

        return new Promise((resolve, reject) => {
          http.post(api, qs.stringify(params)).then(response => {
            let status = response.data.Function.success
            if (status !== true) {
              reject()
              return false
            }
            resolve()
          })
        })
      }

      let isAuthenticated = function () {
        let params = {
          function: 'autho',
          method: 'autho'
        }

        return new Promise((resolve, reject) => {
          http.post(api, qs.stringify(params)).then(response => {
            let status = response.data.Function.success
            if (!status) {
              reject(status)
              return false
            }
            resolve(true)
          })
        })
      }
      return {
        login,
        logout,
        isAuthenticated,
        step1,
        step2
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth-sdk.js